"use client";

import { useContext } from "react";
import { DataHandlerContext } from "./DataHandler";

/** @type {import("../../components/DataHandler/DataHandler").DataHandlerContextValue} */
export const DEFAULT_VALUE = {
  loadingElement: null,
  ErrorComponent: () => null,
  noResultElement: null,
};

/**
 * @returns {import("../../components/DataHandler/DataHandler").DataHandlerContextValue}
 */
export function useDataHandler() {
  const value = useContext(DataHandlerContext);
  if (value === DEFAULT_VALUE) {
    throw new Error("useDataHandler must be used within a DataHandlerProvider");
  }
  return value;
}
